export const EasingFunctions = {
  // no easing, no acceleration
  linear(t) { return t; },
  // accelerating from zero velocity
  easeInQuad(t) { return t * t; },

  // decelerating to zero velocity
  easeOutQuad(t) { return t * (2 - t); },

  // acceleration until halfway, then deceleration
  easeInOutQuad(t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; },

  // accelerating from zero velocity
  easeInCubic(t) { return t * t * t; },

  // decelerating to zero velocity
  easeOutCubic(p) {
    const t = p - 1;
    return t * t * t + 1;
  },

  // acceleration until halfway, then deceleration
  easeInOutCubic(t) {
    return t < 0.5
      ? 4 * t * t * t
      : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
  },

  // accelerating from zero velocity
  easeInQuart(t) { return t * t * t * t; },

  // decelerating to zero velocity
  easeOutQuart(p) {
    const t = p - 1;
    return 1 - t * t * t * t;
  },

  // acceleration until halfway, then deceleration
  easeInOutQuart(t) {
    return t < 0.5
      ? 8 * t * t * t * t
      // eslint-disable-next-line no-param-reassign
      : 1 - 8 * (--t) * t * t * t; // eslint-disable-line no-plusplus
  },

  // accelerating from zero velocity
  easeInQuint(t) { return t * t * t * t * t; },

  // decelerating to zero velocity
  easeOutQuint(t) {
    // eslint-disable-next-line no-param-reassign
    return 1 + (--t) * t * t * t * t; // eslint-disable-line no-plusplus
  },

  // acceleration until halfway, then deceleration
  easeInOutQuint(t) {
    return t < 0.5
      ? 16 * t * t * t * t * t
      // eslint-disable-next-line no-param-reassign
      : 1 + 16 * (--t) * t * t * t * t; // eslint-disable-line no-plusplus
  },
};


export function animation(onIteration) {
  let running = false;
  let duration = 0;

  return {
    isRunning() {
      return running;
    },

    cancel() {
      running = false;
    },

    start(durationMs) {
      running = true;
      duration = durationMs;
      let startTime = null;

      return new Promise((resolve) => {
        function step(timestamp) {
          if (!running) resolve(false);
          // Define the start time, if not defined.
          if (!startTime) startTime = timestamp;

          // Represent the progress as a number from 0.0 -> 1.0
          const progress = duration === 0
            ? 1.0 // No animation, we are done!
            : Math.min(1, (timestamp - startTime) / duration);

          // Call the onIteration function with our current progress.
          onIteration(progress);

          // Stop rendering once we have reach 100%.
          if (progress < 1) {
            window.requestAnimationFrame(step);
          } else resolve(true);
        }

        window.requestAnimationFrame(step);
      });
    },
  };
}
